import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Appfooter from '../components/Appfooter';
import LeftMenu from '../components/LeftMenu';
import { getFollowers } from '../services/feed';
import { Spinner } from 'react-bootstrap';
import i18n from '../utils/i18n';
import { useNavigate } from 'react-router-dom';
// import Button from '../components/Button';
// import { follow, unfollow } from '../services/user';
import { useCallback } from 'react';

type Data = {
  follow: {
    userId: string;
    creatorId: string;
  };
  username: string;
  avatar?: string;
};

const Following = () => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<Data[]>([]);
  // const [followingStatus, setFollowingStatus] = useState<{
  //   [key: string]: boolean;
  // }>({});
  // const [showUnfollowModal, setShowUnfollowModal] = useState(false);
  // const [selectedUsername, setSelectedUsername] = useState('');

  const load = useCallback(async () => {
    try {
      const items = await getFollowers();
      setItems(items);
      // // Initialize all as following
      // const initialStatus: { [key: string]: boolean } = {};
      // items.forEach((item) => {
      //   initialStatus[item.username] = true;
      // });
      // setFollowingStatus(initialStatus);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const navigate = useNavigate();

  // const handleFollowToggle = (username: string) => {
  //   if (followingStatus[username]) {
  //     // Se já está seguindo, mostrar modal de confirmação
  //     setSelectedUsername(username);
  //     setShowUnfollowModal(true);
  //   } else {
  //     // Se não está seguindo, seguir diretamente
  //     handleFollow(username);
  //   }
  // };

  // const confirmUnfollow = async () => {
  //   try {
  //     setLoading(true);
  //     setShowUnfollowModal(false);

  //     const creator = items.find((item) => item.username === selectedUsername);

  //     if (creator) {
  //       await unfollow(creator.follow.creatorId);
  //       await load();
  //     }
  //   } catch (error) {
  //     console.error('Error', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleFollow = async (username: string) => {
  //   try {
  //     setLoading(true);
  //     setShowUnfollowModal(false);

  //     const creator = items.find((item) => item.username === selectedUsername);

  //     if (creator) {
  //       await follow(creator.follow.creatorId);
  //       await load();
  //     }
  //   } catch (error) {
  //     console.error('Error', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <Header />
      <LeftMenu />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                {loading ? (
                  <div
                    className="align-self-center d-flex flex-column justify-content-center align-items-center"
                    style={{
                      padding: 100,
                    }}
                  >
                    <Spinner
                      animation="border"
                      role="status"
                      className="text-warning"
                    />
                  </div>
                ) : (
                  <>
                    <div className="card-body p-4 p-lg-5 w-100 border-0">
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <h4 className="font-md text-grey-900 fw-700 mb-0">
                          {i18n.t<string>('Following.title', {
                            number: items.length,
                          })}
                        </h4>
                      </div>

                      {items.length ? (
                        <div className="row">
                          <div className="col-12">
                            {items.map((value, index) => (
                              <div
                                key={index}
                                className="d-flex align-items-center p-3 border-bottom"
                              >
                                {/* Avatar */}
                                <div
                                  className="avatar me-2 me-md-3 cursor-pointer flex-shrink-0 d-flex"
                                  style={{
                                    width: '45px',
                                    height: '45px',
                                  }}
                                  onClick={() => navigate(`/${value.username}`)}
                                >
                                  <img
                                    src={
                                      value.avatar ||
                                      'assets/images/user-100x100.png'
                                    }
                                    alt={value.username}
                                    className="rounded-circle"
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                    }}
                                  />
                                </div>

                                {/* User Info */}
                                <div
                                  className="flex-grow-1 cursor-pointer"
                                  onClick={() => navigate(`/${value.username}`)}
                                  style={{ minWidth: 0 }}
                                >
                                  <h4
                                    className="fw-700 text-grey-900 mb-0 cursor-pointer font-xsss"
                                    // onClick={() =>
                                    //   navigate(`/${value.username}`)
                                    // }
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {value.username}
                                  </h4>
                                  <p
                                    className="fw-500 text-grey-500 mb-0 font-xssss"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    @{value.username}
                                  </p>
                                </div>

                                {/* Follow Button */}
                                {/* <button
                                  className={`btn btn-sm fw-600 rounded-xxl ms-2 flex-shrink-0 ${
                                    followingStatus[value.username]
                                      ? 'bg-greylight text-grey-900'
                                      : 'bg-dark text-white'
                                  }`}
                                  style={{
                                    minWidth: '100px',
                                    fontSize: '12px',
                                    padding: '6px 12px',
                                  }}
                                  onClick={() =>
                                    handleFollowToggle(value.username)
                                  }
                                >
                                  {followingStatus[value.username]
                                    ? 'Deixar de seguir'
                                    : 'Seguir'}
                                </button> */}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="align-self-center d-flex flex-column justify-content-center align-items-center p-5">
                          <img
                            src="assets/images/logo-blank.png"
                            alt="empty"
                            style={{
                              width: 50,
                              height: 50,
                              objectFit: 'contain',
                            }}
                          />
                          <span className="text-grey-600 m-2 text-center font-xss">
                            {i18n.t<string>('Following.noFollowing')}
                          </span>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal show={showUnfollowModal}>
        <Modal.Header
          closeButton
          onClick={() => setShowUnfollowModal(false)}
          className="bg-white"
          style={{
            border: 0,
            borderRadius: 0,
            padding: 20,
            borderTopLeftRadius: 10,
            WebkitBorderTopRightRadius: 10,
          }}
        />
        <Modal.Body className="bg-white">
          <h2 className="text-center fw-600">{selectedUsername}</h2>
          <p className="font-xs text-black text-center">
            Deseja realmente deixar de seguir?
          </p>
        </Modal.Body>
        <Modal.Footer className="bg-white d-flex flex-row">
          <div className="form-group mb-1 flex-grow-1">
            <button
              onClick={() => setShowUnfollowModal(false)}
              className="form-control text-center text-white fw-600 bg-dark border-0 p-0"
            >
              Não
            </button>
          </div>
          <div className="form-group mb-1 flex-grow-1">
            <Button onClick={confirmUnfollow}>Confirmar</Button>
          </div>
        </Modal.Footer>
      </Modal> */}
      <Appfooter />
    </>
  );
};

export default Following;
